import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { PageHeader } from "@excoleadershipui/pionweblib";
import { useFormik } from "formik";
import * as Yup from "yup";
import { countries, continents } from "countries-list";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { format } from "date-fns";
import { DateTime } from "luxon";

// material ui
import { makeStyles } from "@mui/styles";
import {
  Box,
  Grid,
  InputLabel,
  MenuItem,
  FormControl,
  FormHelperText,
  Select,
  IconButton,
  Autocomplete,
  TextField,
  Input,
  Stack,
  Dialog,
  DialogTitle,
  DialogContent,
  Chip,
  Typography,
  Tooltip,
} from "@mui/material";
// icons
import SettingsIcon from "@mui/icons-material/Settings";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import CancelIcon from "@mui/icons-material/Cancel";
import DeleteIcon from "@mui/icons-material/Delete";
import ArchiveIcon from "@mui/icons-material/Archive";
import ViewCozyIcon from "@mui/icons-material/ViewCozy";
import UnarchiveIcon from "@mui/icons-material/Unarchive";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import QueryBuilderIcon from "@mui/icons-material/QueryBuilder";
import UploadIcon from "@mui/icons-material/Upload";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";

import FileDownloadIcon from "@mui/icons-material/FileDownload";
// components
import Layout from "../../layout/Layout";
import { ASSESSMENT_BASE_URL } from "../../utils/config";
import {
  MuiDataGrid,
  MuiAutocomplete,
  geographyArr,
  GridCellExpand,
  ModalPopUp,
  FormSubmitButton,
  FormTextField as MyTextInput,
  Notifier,
  ErrorNotifier,
  ModalCloseBtn,
  ConfirmDialog,
  MuiTooltip,
  CommonCurdPopUp,
} from "../../components";
import { HeaderDropDown } from "../../components/common/HeaderDropdown";
import { getFormattedDate,dateSortComparator } from "../../components/common/dataValidation";
import { isCheckingAssessmentType } from "../../components/common/IsCheckingAssessmentType";
// redux
import {
  createPublishAssessment,
  getPublishAssessment,
  getPublishAssessmentById,
  getPublishAssessmentByCustomerId,
  updatePublishAssessment,
  deletePublishAssessment,
  batchUploadCustomerUser,
  getArchivedPublishAssessment,
  updateArchivedPublishAssessment,
  forceDeletePublishAssessment,
  getBatchPublishAssessmentById,
  createAssessmentExistingBatch,
  deletePublishAssessmentFromGroup,
  getBatchByTrackingId,
  rowSelect,
  resetMessage,
  resetErrMessage,
} from "../../features/config_and_publish/publishAssessmentSlice";
import { getAssessmentTemplate } from "../../features/prepare_assessments/prepareAssessmentSlice";
import {
  getAccount,
  getAccountById,
} from "../../features/customer/accountSlice";
import { getCustomer } from "../../features/customer/customerSlice";
import { getCustUser } from "../../features/customer/custUserSlice";
import { getAssessmentStatus } from "../../features/config/assessmentStatusSlice";
import MicrositeConfirmDialog from "../customer_management/microsites/MicrositeConfirmDialog";

import CommonCrudPopup from "../../components/form_components/CommonCrudPopup";
import {
  getassessmentType,
  setAssessmentType,
} from "../../features/config/assessmentTypeSlice";
// ------------------------------------------------------------------------------



const validationSchema = Yup.object({
  assessment: Yup.object()
    .nullable()
    .required("Assessment Template Name is required"),
  assessmentType: Yup.object()
    .nullable()
    .required("Assessment Type is required"),
  templateDisplayName: Yup.string()
    .nullable()
    .required("Template Display Name is required"),
  account: Yup.object().nullable().required("Account Name is required"),
  client: Yup.object().nullable().required("Client is required"),
  comments: Yup.string(),
  custName: Yup.object().nullable().required("Customer is required"),
});

const editValidationSchema = Yup.object({
  assessment: Yup.object()
    .nullable()
    .required("Assessment Template Name is required"),
  // account: Yup.object().required("Account is required"),
  // custName: Yup.string().required("Customer is required"),
  account: Yup.object().required("Account Name is required"),
  custName: Yup.object().required("Customer is required"),
  client: Yup.string().required("Client is required"),
  status: Yup.string().required("Status is required"),
  comments: Yup.string().nullable(),
});

// -------------------------------------------------------------------------

const style = {
  position: "absolute",
  top: "50%",
  left: "60%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  borderRadius: "5px",
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
};

// ------------------------------------------------------------------------

const useStyles = makeStyles((theme) => ({
  rootbox: {
    position: "absolute !important",
    top: "50% !important",
    left: "60% !important",
    transform: "translate(-50%, -50%) !important",
    width: "56.25rem !important",
    [theme.breakpoints.down("sm")]: {
      width: "20rem !important",
      height: "60% !important",
      display: "block !important",
      overflow: "scroll !important",
    },
    [theme.breakpoints.between("sm", "md")]: {
      width: "33.375rem !important",
      height: "49% !important",
      display: "block !important",
      overflow: "scroll !important",
      // margin: '-3.188rem',
      marginTop: "-3.75rem  !important",
      marginLeft: "-3.563rem",
      padding: "2.125rem !important",
    },
    background: "#fff !important",
    borderRadius: "0.313rem !important",
    boxShadow: "1.5rem !important",
    paddingTop: "1rem !important",
    paddingLeft: "2rem !important",
    paddingRight: "2rem !important",
    paddingBottom: "1.5rem",
    display: "flex !important",
    flexDirection: "column !important",
    justifyContent: "center !important",
    alignItems: "center !important",
  },

  text_responsive: {
    width: "50rem",
    [theme.breakpoints.down("md")]: {
      width: "17rem",
    },
  },

  cutoff_box: {
    [theme.breakpoints.down("sm")]: {
      width: "16.875rem !important",
    },
    [theme.breakpoints.between("sm", "lg")]: {
      width: "20.875rem !important",
      marginLeft: "-7.313rem",
      marginTop: "-11.313rem",
    },
  },
  responsive_field: {
    [theme.breakpoints.down("sm")]: {
      width: "15rem !important",
    },
  },
  responsive_field: {
    [theme.breakpoints.down("md")]: {
      width: "15rem !important",
    },
  },
  iconResponsive: {
    [theme.breakpoints.down("md")]: {
      marginRight: "-7rem",
    },
  },
}));

const ConfigAndPublish = (props) => {
  const [showAdd, setShowAdd] = useState(false);
  const [open, setOpen] = useState(false);
  const [batchName, setBatchName] = useState(null);
  // const [assessmentType, setAssessmentType] = useState(null)
  const [showEdit, setShowEdit] = useState(false);
  const [viewArchived, setViewArchived] = useState(false);
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const [forceDelConfirmDialog, setForceDelConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const [showCutoffDate, setShowCutoffDate] = useState(false);
  const [cutoffDateSelectedData, setCutoffDateSelectedData] = useState({});
  const [showReminderFreq, setShowReminderFreq] = useState(false);
  const [reminderFreqSelectedData, setReminderFreqSelectedData] = useState({});
  const [selectedCustValue, setSelectedCustValue] = useState(null);
  const [selectedAccountValue, setSelectedAccountValue] = useState(null);
  const [dateErr, setDateErr] = useState("");

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const {
    message,
    errMessage,
    batchDataByTracking,
    batchAssessmentListViewData,
    publishAssessmentData,
    selectedData,
    loading,
  } = useSelector((state) => ({ ...state.publishAssessment }));

  const { assessmentTemplateData } = useSelector((state) => ({
    ...state.prepareAssessment,
  }));
  const { assessmentTypeData, assessmentType } = useSelector((state) => ({
    ...state.assessmentTypeConfig,
  }));

  const {
    accountData,
    accountIdData,
    selectedAccountDataList,
    selectedCustomerDataList,
  } = useSelector((state) => ({ ...state?.account }));
  const { customersData } = useSelector((state) => ({ ...state.customer }));

  const { custUserData } = useSelector((state) => ({ ...state?.custUser }));

  const { assessmentStatusData } = useSelector((state) => ({
    ...state?.assessmentStatus,
  }));

  const showAddModel = () => {
    setShowAdd(!showAdd);
  };

  const closeModel = () => {
    setShowAdd(false);
    const { account, custName } = formik?.values;
    formik.resetForm({
      values: {
        account,
        custName,
        assessmentType: assessmentType,
        assessment: "",
        client: "",
        status: "",
        comments: "",
      },
    });
    // dispatch(getAccount())
  };

  const showEditModal = () => {
    setShowEdit(true);
    // const { account, custName } = formikEdit?.values
    // formikEdit.resetForm({
    //   values: {
    //     account,
    //     custName,
    //     assessment: "",
    //     client: "",
    //     status: "",
    //     comments: "",
    //   },
    // });
  };
  const closeEditModal = () => {
    setShowEdit(false);
  };

  const showCutoffDateModal = (data) => {
    setShowCutoffDate(true);
    setCutoffDateSelectedData(Object.keys(data)?.length > 0 ? data : {});
  };

  const closeCutoffDateModal = () => {
    setShowCutoffDate(false);
  };

  const showReminderFreqModal = (data) => {
    setShowReminderFreq(true);
    setReminderFreqSelectedData(data);
  };

  const closeReminderFreqModal = () => {
    setShowReminderFreq(false);
  };

  const showDelete = () =>
    setConfirmDialog({
      isOpen: true,
      title: "Are you sure to delete this record?",
      subTitle: "You can't undo this operation",
      onConfirm: () => handleDeleteCustomer(),
    });

  const handleDeleteCustomer = () => {
    let data = {
      id: selectedData?.id,
    };
    dispatch(deletePublishAssessment(data)).then((res) => {
      if (res?.payload?.data?.ok) {
        setTimeout(() => {
          dispatch(resetMessage());
          setConfirmDialog({
            ...confirmDialog,
            isOpen: false,
          });
          if (selectedCustValue && selectedAccountValue) {
            dispatch(
              getPublishAssessmentById({
                assessmentCustomerAccountId: selectedAccountValue?.id,
              }),
            );
          } else if (selectedCustValue) {
            dispatch(
              getPublishAssessmentByCustomerId({
                assessmentCustomerId: selectedCustValue?.id,
              }),
            );
          } else {
            dispatch(getPublishAssessment());
          }
        }, 2000);
      }
      if (res?.payload?.error) {
        setTimeout(() => {
          dispatch(resetErrMessage());
        }, 3000);
      }
    });
  };

  const handleSetConfirmDialog = (obj) => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: obj.isOpen,
    });
  };

  //based on the change in dropdown the the change the Object in Navigate

  function getAssessment(value, params) {
    return params?.assessmentTemplate?.assessmentTemplateDisplayName;
  }

  function getAssessmentTemplateMui(value, params) {
    return params?.assessmentTemplate?.assessmentTemplateName;
  }

  function getClient(value, params) {
    return `${
      params.assessmentCustomerUser?.assessmentCustomerUserDetail?.firstName ||
      ""
    } ${
      params.assessmentCustomerUser?.assessmentCustomerUserDetail?.lastName ||
      ""
    }`;
  }

  function getClientEmail(params) {
    return (
      <GridCellExpand
        value={params?.row?.assessmentCustomerUser?.email}
        width={params?.colDef?.computedWidth}
      />
    );
  }

  function getAccountName(params) {
    return (
      <GridCellExpand
        value={`${params?.row?.assessmentCustomerUser?.assessmentCustomer?.customerName}-${params?.row?.assessmentCustomerUser?.assessmentCustomer?.accountName}`}
        width={params?.colDef?.computedWidth}
      />
    );
  }

  const showForceDelete = (dataId) =>
    setForceDelConfirmDialog({
      isOpen: true,
      title: "Are you sure to delete this record?",
      subTitle: "You can't undo this operation",
      onConfirm: (pass) => handleForceDeletePublishTemplate(pass, dataId),
    });

  const showAssessmentDelete = (batch) => {
    setConfirmDialog({
      isOpen: true,
      title: "Are you sure to remove this record?",
      subTitle: "You can't undo this operation",
      onConfirm: () =>
        handleRemoveBatch(batch?.id, batch.assessmentTracking?.id),
    });
  };

  const handleForceDeletePublishTemplate = (pass, dataId) => {
    let data = {
      id: dataId?.id,
      password: pass,
    };
    dispatch(forceDeletePublishAssessment(data)).then((res) => {
      if (res?.payload?.data?.ok) {
        setTimeout(() => {
          dispatch(resetMessage());
          setForceDelConfirmDialog({
            ...forceDelConfirmDialog,
            isOpen: false,
          });
          if (selectedCustValue && selectedAccountValue) {
            dispatch(
              getPublishAssessmentById({
                assessmentCustomerAccountId: selectedAccountValue?.id,
              }),
            );
          } else if (selectedCustValue) {
            dispatch(
              getPublishAssessmentByCustomerId({
                assessmentCustomerId: selectedCustValue?.id,
              }),
            );
          } else {
            dispatch(getPublishAssessment());
          }
        }, 2000);
      }
      if (res?.payload?.error) {
        setTimeout(() => {
          dispatch(resetErrMessage());
        }, 2000);
      }
    });
  };

  const handleSetForceDelConfirmDialog = (obj) => {
    setForceDelConfirmDialog({
      ...forceDelConfirmDialog,
      isOpen: obj.isOpen,
    });
  };

  function renderCellExpand(params) {
    return (
      <GridCellExpand
        value={params.value || ""}
        width={params.colDef.computedWidth}
      />
    );
  }

  const data = {
    rows: assessmentType
      ? publishAssessmentData?.filter(
          (data) =>
            data.assessmentTemplate?.assessmentType?.assessmentType ===
            assessmentType?.assessmentType,
        )
      : publishAssessmentData?.length > 0
        ? publishAssessmentData
        : [],
    columns: [
      {
        field: "assessment",
        headerName: "Assessment Name",
        width: 150,
        renderCell: renderCellExpand,
        valueGetter: getAssessment,
      },
      {
        field: "client",
        headerName: "Client Name",
        width: 150,
        valueGetter: getClient,
      },
      {
        field: "Email",
        headerName: "Client E-Mail",
        width: 150,
        renderCell: getClientEmail,
        valueGetter: (value, params) => params?.assessmentCustomerUser?.email,
      },

      {
        field: "assessmentTemplate",
        headerName: "Assessment Type",
        width: 200,
        // renderCell: getClientEmail,
        valueGetter: (value, params) =>
          params?.assessmentTemplate?.assessmentType?.assessmentType,
      },
      // {
      //   field: "account",
      //   headerName: "Account",
      //   width: 150,
      //   renderCell: getAccountName,
      //   valueGetter: (params) =>
      //     `${params?.row?.assessmentCustomerUser?.assessmentCustomer?.customerName}-${params?.row?.assessmentCustomerUser?.assessmentCustomer?.accountName}`,
      // },
      {
        field: "cutOffDate",
        headerName: "Cut Off Date",
        width: 130,
        valueGetter: (value, params) =>
          params?.cutOffDate ? getFormattedDate(params?.cutOffDate) : "",
        sortComparator: dateSortComparator,

      },

      ...(!viewArchived
        ? [
            {
              field: "config",
              // hide: viewArchived ? true : false,
              // headerName: 'Actions',
              type: "actions",
              width: 50,
              renderCell: (params) => {
                if (
                  !isCheckingAssessmentType(
                    params?.row?.assessmentTemplate?.assessmentType?.code,
                  )
                )
                  return null;
                return (
                  <MuiTooltip title="Config Assessors" placement="bottom">
                    {!params?.row?.isArchived && (
                      <Link
                        aria-label="config-assessors"
                        to="/exco/publish/map-assessors"
                        state={{
                          trackingSelectedData: params?.row,
                          permissions: location?.state?.permissions,
                          assessmentType: assessmentType,
                          selectedCustValue: selectedCustValue,
                          selectedAccountValue: selectedAccountValue,
                        }}
                      >
                        <SettingsIcon style={{ color: "#808080" }} />
                      </Link>
                    )}
                  </MuiTooltip>
                );
              },
            },
          ]
        : []),
      ...(!viewArchived
        ? [
            {
              field: "Date",
              // hide: viewArchived ? true : false,
              // headerName: 'Actions',
              type: "actions",
              width: 50,
              renderCell: (params) => {
                return (
                  <MuiTooltip title="Set Cut Off Date" placement="bottom">
                    <Link
                      aria-label="set-cutoffdate"
                      onClick={() => showCutoffDateModal(params?.row)}
                      state={{
                        permissions: location?.state?.permissions,
                        assessmentType: assessmentType,
                      }}
                    >
                      {location?.state?.permissions?.find(
                        (e) =>
                          e.applicationService?.name?.split(".")[
                            e?.applicationService?.name?.split(".")?.length - 1
                          ] === "updateAssessTrack",
                      ) &&
                        !params?.row?.isArchived && (
                          <CalendarMonthIcon style={{ color: "#808080" }} />
                        )}
                    </Link>
                  </MuiTooltip>
                );
              },
            },
          ]
        : []),
      // {
      //   field:'Frequency',
      //   // headerName: 'Actions',
      //   type: 'actions',
      //   width: 50,
      //   renderCell: (params) => {
      //     return (
      //       <MuiTooltip title="Set Reminder Frequency" placement="bottom">
      //       <Link onClick={() => showReminderFreqModal(params?.row)} state={{permissions: location?.state?.permissions}} >
      //         <QueryBuilderIcon style={{color: '#808080'}} />
      //       </Link>
      //       </MuiTooltip>
      //     );
      //   },
      // },
      ...(!viewArchived
        ? [
            {
              field: "publish",
              // hide: viewArchived ? true : false,
              // headerName: 'Actions',
              type: "actions",
              width: 50,
              renderCell: (params) => {
                return (
                  <MuiTooltip title="Publish" placement="bottom">
                    <Link
                      aria-label="upload"
                      to="/exco/publish/assessment"
                      state={{
                        trackingSelectedData: params?.row,
                        customer: selectedCustValue,
                        account: selectedAccountValue,
                        permissions: location?.state?.permissions,
                        assessmentType: assessmentType,
                        // selectedCustValue: selectedCustValue,
                        // selectedAccountValue: selectedAccountValue
                      }}
                    >
                      {location?.state?.permissions?.find(
                        (e) =>
                          e.applicationService?.name?.split(".")[
                            e?.applicationService?.name?.split(".")?.length - 1
                          ] === "publishAssessment",
                      ) &&
                        !params?.row?.isArchived && (
                          <UploadIcon style={{ color: "#808080" }} />
                        )}
                    </Link>
                  </MuiTooltip>
                );
              },
            },
          ]
        : []),
      {
        field: "archived",
        // headerName: 'Actions',
        type: "actions",
        width: 50,
        renderCell: (params) => {
          return (
            <MuiTooltip
              title={!params?.row?.isArchived ? "Archive" : "Un Archive"}
              placement="right"
            >
              {!params?.row?.isArchived ? (
                <IconButton
                  aria-label="archive"
                  onClick={() =>
                    dispatch(
                      updateArchivedPublishAssessment({
                        id: params?.row?.id,
                        isArchived: true,
                      }),
                    ).then((res) => {
                      if (res?.payload?.data?.ok) {
                        // setCopyLoading(true);
                        setTimeout(() => {
                          dispatch(resetMessage());
                          if (
                            formik?.values?.custName &&
                            !formik?.values?.account
                          ) {
                            dispatch(
                              getPublishAssessmentByCustomerId({
                                assessmentCustomerId:
                                  formik?.values?.custName?.id,
                              }),
                            );
                          }
                          if (
                            formik?.values?.custName &&
                            formik?.values?.account
                          ) {
                            dispatch(
                              getPublishAssessmentById({
                                assessmentCustomerAccountId:
                                  formik?.values?.account?.id,
                              }),
                            );
                          } else {
                            dispatch(getPublishAssessment());
                          }
                          // setCopyLoading(false);
                        }, 2000);
                      }
                      if (res?.payload?.error) {
                        setTimeout(() => {
                          dispatch(resetErrMessage());
                        }, 3000);
                      }
                    })
                  }
                  color="primary"
                  aria-label="upload picture"
                  component="span"
                >
                  <ArchiveIcon className={classes.iconResponsive} />
                </IconButton>
              ) : (
                <IconButton
                  aria-label="unarchive"
                  onClick={() =>
                    dispatch(
                      updateArchivedPublishAssessment({
                        id: params?.row?.id,
                        isArchived: false,
                      }),
                    ).then((res) => {
                      if (res?.payload?.data?.ok) {
                        // setCopyLoading(true);
                        setTimeout(() => {
                          dispatch(resetMessage());
                          dispatch(
                            getArchivedPublishAssessment({
                              assessmentCustomerId: formik.values.custName?.id,
                              assessmentCustomerAccountId:
                                formik?.values?.accountName?.id,
                            }),
                          );
                          // setCopyLoading(false);
                        }, 2000);
                      }
                      if (res?.payload?.error) {
                        setTimeout(() => {
                          dispatch(resetErrMessage());
                        }, 3000);
                      }
                    })
                  }
                  color="primary"
                  aria-label="upload picture"
                  component="span"
                >
                  <UnarchiveIcon className={classes.iconResponsive} />
                </IconButton>
              )}
            </MuiTooltip>
          );
        },
      },
      // {
      //   field: "colorCode",
      //   headerName: "Status",
      //   // type: "actions",
      //   width: 50,
      //   renderCell: (params) => {
      //     return (
      //       <>
      //         <MuiTooltip
      //           title={params?.row?.assessmentStatus}
      //           placement="bottom"
      //         >
      //           <div
      //             style={{
      //               backgroundColor: assessmentStatusData
      //                 .filter(
      //                   (value) =>
      //                     value?.assessmentStatus ===
      //                     params?.row?.assessmentStatus,
      //                 )
      //                 .map((option) => option?.colorCode),
      //               width: "20px",
      //               height: "20px",
      //               border: `1px solid ${assessmentStatusData
      //                 .filter(
      //                   (value) =>
      //                     value?.assessmentStatus ===
      //                     params?.row?.assessmentStatus,
      //                 )
      //                 .map((option) => option?.colorCode)}`,
      //               borderRadius: "100%",
      //             }}
      //           ></div>
      //         </MuiTooltip>
      //       </>
      //     );
      //   },
      // },
      {
        field: "colorCode",
        headerName: "Status",
        width: 100,
        align: "center",
        headerAlign: "center",
        renderCell: (params) => {
          const colorCode = assessmentStatusData?.find(
            (value) =>
              value?.assessmentStatus === params?.row?.assessmentStatus,
          )?.colorCode;

          return (
            <MuiTooltip
              title={params?.row?.assessmentStatus}
              placement="bottom"
            >
              <div
                role="img"
                aria-label={`Assessment status: ${params?.row?.assessmentStatus}`}
                style={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <div
                  aria-hidden="true"
                  style={{
                    backgroundColor: colorCode,
                    width: "20px",
                    height: "20px",
                    border: `1px solid ${colorCode}`,
                    borderRadius: "50%",
                  }}
                />
              </div>
            </MuiTooltip>
          );
        },
      },
      ...(!viewArchived
        ? [
            {
              field: "tagBatch",
              type: "actions",
              width: 70,
              renderCell: (params) => {
                if (params?.row?.isPublished) {
                  return null;
                }

                return (
                  <MuiTooltip title="Tag to Batch" placement="right">
                    <IconButton
                      aria-label="Tag to Batch"
                      color="primary"
                      sx={{ p: 0 }}
                      onClick={() => {
                        setOpen(true);
                        setBatchName(null);

                        dispatch(getBatchByTrackingId(params?.row?.id));
                        dispatch(rowSelect([params?.row]));

                        dispatch(
                          getBatchPublishAssessmentById({
                            customerId:
                              params?.row?.assessmentCustomerUser
                                ?.assessmentCustomerAccount?.assessmentCustomer
                                ?.id,
                            accountId:
                              params?.row?.assessmentCustomerUser
                                ?.assessmentCustomerAccount?.id,
                          }),
                        );
                      }}
                    >
                      <LocalOfferIcon aria-hidden="true" />
                    </IconButton>
                  </MuiTooltip>
                );
              },
            },
          ]
        : []),

      ...(!viewArchived
        ? [
            {
              field: "forceDelete",
              // headerName: 'Clone',
              type: "actions",
              // hide: viewArchived ? true : false,

              width: 70,
              renderCell: (params) => {
                return (
                  <MuiTooltip title="Force Delete" placement="right">
                    {location?.state?.permissions?.find(
                      (e) =>
                        e.applicationService?.name?.split(".")[
                          e?.applicationService?.name?.split(".")?.length - 1
                        ] === "forceDelAssessTrack",
                    ) &&
                      !params?.row?.isArchived && (
                        <IconButton
                          aria-label="delete"
                          sx={{ p: 0 }}
                          onClick={() => showForceDelete(params?.row)}
                        >
                          <DeleteIcon style={{ color: "#FF0000" }} />
                        </IconButton>
                      )}
                  </MuiTooltip>
                );
              },
            },
          ]
        : []),
      {
        field: "AssessmentTemplateName",
        headerName: "Assessment Template Name",
        width: 220,
        renderCell: renderCellExpand,
        valueGetter: getAssessmentTemplateMui,
      },
      // {field: "reminderFrequency", headerName: "Reminder Frequency", width: 150},

      {
        field: "customer",
        headerName: "Customer Name",
        width: 200,
        valueGetter: (value, params) =>
          params?.assessmentCustomerUser?.assessmentCustomerAccount
            ?.assessmentCustomer?.customerName,

        renderCell: renderCellExpand,
      },
      {
        field: "account",
        headerName: "Account Name",
        width: 200,
        valueGetter: (value, params) =>
          params?.assessmentCustomerUser?.assessmentCustomerAccount
            ?.accountName,

        renderCell: renderCellExpand,
      },
      {
        field: "comments",
        headerName: "Comments",
        width: 250,
        renderCell: renderCellExpand,
      },
    ],
  };

  useEffect(() => {
    if (location.state?.customer) {
      setSelectedCustValue(location.state.customer);
    }

    if (location.state?.account) {
      setSelectedAccountValue(location.state.account);
    }
  }, [location.state, dispatch]);

  console.log(selectedCustValue);

  const formik = useFormik({
    reset: true,
    initialValues: {
      assessment: "",
      assessmentType: null,
      templateDisplayName: "",
      customerSelectedData: "",
      accountSelectedData: "",
      account: "",
      custName: "",
      client: "",
      comments: "",
    },

    validationSchema: validationSchema,
    onSubmit: async (values, onSubmitProps) => {
      const res = await dispatch(
        createPublishAssessment({
          assessmentTemplateId: values.assessment?.id,
          // assessmentTypeId: values?.assessmentType?.id,
          assessmentCustomerUserId: values.client?.id,
          comments: values.comments,
        }),
      ).then((res) => {
        if (res?.payload?.data?.ok) {
          setTimeout(() => {
            dispatch(resetMessage());
            closeModel();
            selectedCustValue && !selectedAccountValue
              ? dispatch(
                  getPublishAssessmentByCustomerId({
                    assessmentCustomerId: selectedCustValue?.id,
                  }),
                )
              : selectedAccountValue
                ? dispatch(
                    getPublishAssessmentById({
                      assessmentCustomerAccountId: selectedAccountValue?.id,
                    }),
                  )
                : dispatch(getPublishAssessment());
            onSubmitProps.resetForm();
          }, 2000);
          return true;
        }
        if (res?.payload?.error) {
          setTimeout(() => {
            dispatch(resetErrMessage());
          }, 3000);
        }
        return false;
      });
      return res;
    },
  });
  const formikEdit = useFormik({
    enableReinitialize: true,
    initialValues: {
      custName: "",
      account: "",
      assessmentType: selectedData?.assessmentTemplate?.assessmentType?.id,
      customerSelectedData: "",
      accountSelectedData: "",
      assessment: selectedData?.assessmentTemplate,
      templateDisplayName:
        selectedData?.assessmentTemplate?.assessmentTemplateDisplayName,

      client: selectedData?.assessmentCustomerUser?.id,
      status: selectedData?.assessmentStatus,
      cutoffDate:
        Object.keys(cutoffDateSelectedData)?.length > 0 &&
        cutoffDateSelectedData?.cutOffDate
          ? cutoffDateSelectedData?.cutOffDate?.substring(0, 10).split("-")[0] +
            "-" +
            cutoffDateSelectedData?.cutOffDate?.substring(0, 10).split("-")[1] +
            "-" +
            cutoffDateSelectedData?.cutOffDate?.substring(0, 10).split("-")[2]
          : "",
      reminderFreq: reminderFreqSelectedData?.reminderFrequency,
      comments: selectedData?.comments,
    },

    validationSchema: showEdit && editValidationSchema,
    onSubmit: async (values) => {
      const dateResult = DateTime.fromISO(values?.cutoffDate).set({
        hour: 0,
        minute: 0,
        second: 0,
        millisecond: 0,
      });
      let localIsoString = dateResult.toISO();

      if (values?.status === "Completed") {
        setConfirmDialog({
          isOpen: true,
          title: `The Assessment  will be closed for ${
            selectedData?.assessmentCustomerUser?.assessmentCustomerUserDetail
              ?.firstName
          } ${
            selectedData?.assessmentCustomerUser?.assessmentCustomerUserDetail
              ?.lastName
          } ..You will not be able to modify the status further. Please confirm.`,
          subTitle: "You can't undo this operation",
          onConfirm: () => handleUpdateIsCompletedCustomer(),
        });
      } else {
        const res = await dispatch(
          updatePublishAssessment(
            // showCutoffDate ? {
            //   id: cutoffDateSelectedData?.id,
            //   cutOffDate: values?.cutoffDate,
            //   assessmentTemplateId:cutoffDateSelectedData?.assessmentTemplate?.id,
            //   assessmentCustomerUserId: cutoffDateSelectedData?.assessmentCustomerUser?.id,
            //   assessmentStatus: cutoffDateSelectedData?.assessmentStatus,
            // } : showReminderFreq ? {
            //   id: reminderFreqSelectedData?.id,
            //   reminderFrequency: values?.reminderFreq.toString(),
            //   assessmentTemplateId:reminderFreqSelectedData?.assessmentTemplate?.id,
            //   assessmentCustomerUserId: reminderFreqSelectedData?.assessmentCustomerUser?.id,
            //   assessmentStatus: reminderFreqSelectedData?.assessmentStatus,
            // } :
            {
              id: selectedData?.id,
              assessmentTemplateId: values.assessment?.id,
              assessmentCustomerUserId: values.client,
              assessmentStatus: values?.status,
              // cutOffDate: localIsoString,
              reminderFrequency: values?.reminderFreq,
              comments: values?.comments,
            },
          ),
        ).then((res) => {
          if (res?.payload?.data?.ok) {
            setTimeout(() => {
              dispatch(resetMessage());
              closeEditModal();
              closeCutoffDateModal();
              closeReminderFreqModal();
              selectedCustValue && !selectedAccountValue
                ? dispatch(
                    getPublishAssessmentByCustomerId({
                      assessmentCustomerId: selectedCustValue?.id,
                    }),
                  )
                : selectedAccountValue
                  ? dispatch(
                      getPublishAssessmentById({
                        assessmentCustomerAccountId: selectedAccountValue?.id,
                      }),
                    )
                  : dispatch(getPublishAssessment());
            }, 2000);
            return true;
          }
          if (res?.payload?.error) {
            setTimeout(() => {
              dispatch(resetErrMessage());
            }, 3000);
          }
          return false;
        });
        return res;
      }
      // if(!dateErr) {

      // }
    },
  });

  const handleUpdateIsCompletedCustomer = () => {
    const dateResult = DateTime.fromISO(formikEdit?.values?.cutoffDate).set({
      hour: 0,
      minute: 0,
      second: 0,
      millisecond: 0,
    });
    let localIsoString = dateResult.toISO();

    let data = {
      id: selectedData?.id,
      assessmentTemplateId: formikEdit?.values.assessment?.id,
      assessmentCustomerUserId: formikEdit?.values.client?.id,

      assessmentStatus: formikEdit?.values?.status,
      cutOffDate: localIsoString,
      reminderFrequency: formikEdit?.values?.reminderFreq,
      comments: formikEdit?.values?.comments,
    };
    dispatch(updatePublishAssessment(data)).then((res) => {
      if (res?.payload?.data?.ok) {
        setTimeout(() => {
          dispatch(resetMessage());
          closeEditModal();
          closeCutoffDateModal();
          closeReminderFreqModal();
          setConfirmDialog({
            ...confirmDialog,
            isOpen: false,
          });
          selectedCustValue && !selectedAccountValue
            ? dispatch(
                getPublishAssessmentByCustomerId({
                  assessmentCustomerId: selectedCustValue?.id,
                }),
              )
            : selectedAccountValue
              ? dispatch(
                  getPublishAssessmentById({
                    assessmentCustomerAccountId: selectedAccountValue?.id,
                  }),
                )
              : dispatch(getPublishAssessment());
        }, 2000);
      }
      if (res?.payload?.error) {
        setTimeout(() => {
          setConfirmDialog({
            ...confirmDialog,
            isOpen: false,
          });
          dispatch(resetErrMessage());
        }, 3000);
      }
    });
  };

  const formikCutoffDateEdit = useFormik({
    enableReinitialize: true,
    initialValues: {
      assessment: selectedData?.assessmentTemplate,
      templateDisplayName: "",
      account: selectedData?.assessmentCustomerUser?.assessmentCustomer,
      client: selectedData?.assessmentCustomerUser?.id,
      status: selectedData?.assessmentStatus,
      cutoffDate:
        Object.keys(cutoffDateSelectedData)?.length > 0
          ? cutoffDateSelectedData?.cutOffDate &&
            getFormattedDate(cutoffDateSelectedData?.cutOffDate)
              .split(",")[0]
              ?.split("/")[2] +
              "-" +
              getFormattedDate(cutoffDateSelectedData?.cutOffDate)
                .split(",")[0]
                ?.split("/")[0] +
              "-" +
              getFormattedDate(cutoffDateSelectedData?.cutOffDate)
                .split(",")[0]
                ?.split("/")[1]
          : "",
      reminderFreq: reminderFreqSelectedData?.reminderFrequency,
      comments: selectedData?.comments,
    },

    validationSchema: showEdit && editValidationSchema,
    onSubmit: async (values) => {
      const dateResult = DateTime.fromISO(values?.cutoffDate).set({
        hour: 0,
        minute: 0,
        second: 0,
        millisecond: 0,
      });
      let localIsoString = dateResult.toISO();
      if (!dateErr) {
        const res = await dispatch(
          updatePublishAssessment(
            // showCutoffDate ? {
            {
              id: cutoffDateSelectedData?.id,
              cutOffDate: localIsoString,
              assessmentTemplateId:
                cutoffDateSelectedData?.assessmentTemplate?.id,
              assessmentCustomerUserId:
                cutoffDateSelectedData?.assessmentCustomerUser?.id,
              assessmentStatus: cutoffDateSelectedData?.assessmentStatus,
            },
            //   } : showReminderFreq ? {
            //     id: reminderFreqSelectedData?.id,
            //     reminderFrequency: values?.reminderFreq.toString(),
            //     assessmentTemplateId:reminderFreqSelectedData?.assessmentTemplate?.id,
            //     assessmentCustomerUserId: reminderFreqSelectedData?.assessmentCustomerUser?.id,
            //     assessmentStatus: reminderFreqSelectedData?.assessmentStatus,
            //   } :
            //     {
            //   id: selectedData?.id,
            //   assessmentTemplateId: values.assessment?.id,
            //   assessmentCustomerUserId: values.client?.id,
            //   assessmentStatus: values?.status,
            //   cutOffDate: values?.cutoffDate,
            //   reminderFrequency: values?.reminderFreq,
            //   comments: values?.comments,
            // }
          ),
        ).then((res) => {
          if (res?.payload?.data?.ok) {
            setTimeout(() => {
              dispatch(resetMessage());
              closeEditModal();
              closeCutoffDateModal();
              closeReminderFreqModal();
              selectedCustValue && !selectedAccountValue
                ? dispatch(
                    getPublishAssessmentByCustomerId({
                      assessmentCustomerId: selectedCustValue?.id,
                    }),
                  )
                : selectedAccountValue
                  ? dispatch(
                      getPublishAssessmentById({
                        assessmentCustomerAccountId: selectedAccountValue?.id,
                      }),
                    )
                  : dispatch(getPublishAssessment());
            }, 2000);
            return true;
          }
          if (res?.payload?.error) {
            setTimeout(() => {
              dispatch(resetErrMessage());
            }, 3000);
          }
          return false;
        });
        return res;
      }
    },
  });

  let options = Object.values(countries);

  useEffect(() => {
    // if (!location?.state?.account && !location?.state?.customer) {
    //   console.log("Hitted Succesfully")
    //   dispatch(getPublishAssessment());
    // }
    dispatch(getAssessmentTemplate());
    dispatch(getCustUser());
    dispatch(getAccount());
    dispatch(getCustomer());
    dispatch(getAssessmentStatus());
    dispatch(getassessmentType());
  }, []);

  useEffect(() => {
    formik?.setFieldValue(
      "assessmentType",
      !assessmentType
        ? assessmentTypeData?.find((data) => data.code === "ELI")
        : assessmentType,
    );

    // setAssessmentType(assessmentType ? assessmentType : assessmentTypeData?.find((data) => data.code === "ELI"))
  }, [assessmentTypeData, assessmentType]);

  // useEffect(() => {
  //   setAssessmentType(assessmentTypeData?.find((data) => data.code === "ELI"))
  // }, [assessmentTypeData])
  useEffect(() => {
    // if assessment type is selected no need to call this use effect then the state variable it wont change so that time
    // you will get the state variable stored and it will not be resetted everytime
    if (
      !Boolean(location?.state?.assessmentType) &&
      assessmentTypeData?.length > 0
    ) {
      const defaultType = assessmentTypeData.find(
        (data) => data.code === "ELI",
      );

      if (defaultType) {
        dispatch(setAssessmentType(defaultType));
        formik.setFieldValue("assessmentType", defaultType);
      }
    }
  }, [assessmentTypeData]);

  // resetting the assessment type data if the component unmounts and resetting the ELI Assessment
  // useEffect(() => {
  //   return() =>{
  //     dispatch(setAssessmentType(null));
  //   };
  // },[])

  useEffect(() => {
    if (!formik?.values?.account) {
      formik.setFieldValue("client", "");
    }
  }, [formik?.values?.account]);

  useEffect(() => {
    // templateDisplayName
    formik.setFieldValue(
      "templateDisplayName",
      formik.values.assessment?.assessmentTemplateDisplayName
        ? formik.values.assessment?.assessmentTemplateDisplayName
        : "",
    );
  }, [formik.values.assessment]);

  useEffect(() => {
    // templateDisplayName
    formikEdit.setFieldValue(
      "templateDisplayName",
      formikEdit.values.assessment?.assessmentTemplateDisplayName
        ? formikEdit.values.assessment?.assessmentTemplateDisplayName
        : "",
    );
  }, [formikEdit.values.assessment]);

  // useEffect(() => {
  //   if (
  //     formikEdit?.values?.account?.id !==
  //     selectedData?.assessmentCustomerUser?.assessmentCustomer?.id
  //   ) {
  //     formikEdit.setFieldValue("client", "");
  //   }
  // }, [formikEdit?.values?.account]);

  useEffect(() => {
    if (
      formikCutoffDateEdit?.values?.cutoffDate &&
      (formikCutoffDateEdit?.values?.cutoffDate)
        .substring(0, 10)
        .split("-")[0] +
        "-" +
        (formikCutoffDateEdit?.values?.cutoffDate)
          .substring(0, 10)
          .split("-")[1] +
        "-" +
        (formikCutoffDateEdit?.values?.cutoffDate)
          .substring(0, 10)
          .split("-")[2] <
        format(new Date(), "yyyy-MM-dd")
    ) {
      setDateErr(
        "Cut Off Date should be greater than or equal to current date",
      );
    } else if (!formikCutoffDateEdit?.values?.cutoffDate) {
      setDateErr("Please enter cut off date");
    } else {
      setDateErr("");
    }
  }, [formikCutoffDateEdit.values.cutoffDate]);

  useEffect(() => {
    if (formik.values?.custName?.id) {
      dispatch(
        getAccountById({ assessmentCustomerId: formik.values?.custName?.id }),
      );
    }
  }, [formik.values?.custName]);

  // useEffect(() => {
  //   if (!formik?.values?.account) {
  //     dispatch(getPublishAssessment());
  //   }
  //   else {
  //     dispatch(getPublishAssessmentById({ assessmentCustomerAccountId: formik.values?.account?.id }))
  //   }
  // }, [formik.values?.account])

  // useEffect(() => {
  //   if (formikEdit.values?.custName?.id) {
  //     dispatch(getAccountById({ assessmentCustomerId: formikEdit.values?.custName?.id }))
  //   }

  // }, [formikEdit.values?.custName])

  // useEffect(() => {

  //   formik.setFieldValue("account", accountData.find((data) => data?.id === formik?.values?.assessment?.assessmentCustomerAccount?.id)
  //   )
  //   formik.setFieldValue("custName", customersData.find((data) => data?.id === formik?.values?.assessment?.assessmentCustomerAccount?.assessmentCustomer?.id)
  //   )

  // }, [formik.values.assessment])

  useEffect(() => {
    let dataAccounts = accountData?.length > 0 ? accountData : accountIdData;

    formikEdit.setFieldValue(
      "account",
      dataAccounts.find(
        (data) =>
          data?.id ===
          selectedData?.assessmentCustomerUser?.assessmentCustomerAccount?.id,
      ),
    );
    formikEdit.setFieldValue(
      "custName",
      customersData.find(
        (data) =>
          data?.id ===
          selectedData?.assessmentCustomerUser?.assessmentCustomerAccount
            ?.assessmentCustomer?.id,
      ),
    );
    // formikEdit.setFieldValue("client", custUserData.find((data) => data?.id === selectedData?.assessmentCustomerUser?.assessmentCustomerAccount?.id)?.id
    // )
  }, [selectedData]);

  useEffect(() => {
    let dataAccounts = accountData?.length > 0 ? accountData : accountIdData;

    formikEdit.setFieldValue(
      "account",
      dataAccounts.find(
        (data) =>
          data?.id ===
          selectedData?.assessmentCustomerUser?.assessmentCustomerAccount?.id,
      ),
    );
    formikEdit.setFieldValue(
      "custName",
      customersData.find(
        (data) =>
          data?.id ===
          selectedData?.assessmentCustomerUser?.assessmentCustomerAccount
            ?.assessmentCustomer?.id,
      ),
    );
    // formikEdit.setFieldValue("client", custUserData.find((data) => data?.id === selectedData?.assessmentCustomerUser?.assessmentCustomerAccount?.id)?.id
    // )
  }, [cutoffDateSelectedData]);

  const handleFile = (e) => {
    let formdata = new FormData();
    formdata.append("file", e.target.files[0]);

    dispatch(batchUploadCustomerUser(formdata))
      .then((res) => {
        // if (res?.payload?.data?.ok) {
        setTimeout(() => {
          dispatch(resetMessage());

          selectedCustValue && !selectedAccountValue
            ? dispatch(
                getPublishAssessmentByCustomerId({
                  assessmentCustomerId: selectedCustValue?.id,
                }),
              )
            : selectedAccountValue
              ? dispatch(
                  getPublishAssessmentById({
                    assessmentCustomerAccountId: selectedAccountValue?.id,
                  }),
                )
              : dispatch(getPublishAssessment());
        }, 2000);
        // }
        if (res?.error) {
          setTimeout(() => {
            dispatch(resetErrMessage());
          }, 3000);
        }
      })
      .catch((err) => {
        setTimeout(() => {
          dispatch(resetErrMessage());
        }, 2000);
      });

    e.target.value = null;
  };

  const handleAddTrackingAssessmentToBatch = () => {
    let data = {
      batchId: batchName?.id,
      assessmentTrackingIds: [selectedData?.id],
    };
    dispatch(createAssessmentExistingBatch(data)).then((res) => {
      if (res?.payload?.data?.ok) {
        setTimeout(() => {
          dispatch(resetMessage());
          setOpen(false);
        }, 2000);
      }
      if (res?.payload?.error) {
        setTimeout(() => {
          dispatch(resetErrMessage());
        }, 3000);
      }
    });
  };

  const handleRemoveBatch = (batchId, dataId) => {
    console.log(dataId);
    let data = {
      batchId: batchId,
      assessmentTrackingId: dataId,
    };
    dispatch(deletePublishAssessmentFromGroup(data)).then((res) => {
      if (res?.payload?.data?.ok) {
        setTimeout(() => {
          dispatch(resetMessage());
          dispatch(getBatchByTrackingId(dataId));
          setConfirmDialog({
            ...confirmDialog,
            isOpen: false,
          });
          // Array.isArray(batchAssessmentData?.data) ? dispatch(getBatchPublishAssessmentById()) : dispatch(getBatchPublishAssessment({ id: batchAssessmentData?.data?.id }))
        }, 2000);
      }
      if (res?.payload?.error) {
        setTimeout(() => {
          dispatch(resetErrMessage());
        }, 3000);
      }
    });
  };

  // useEffect(() => {
  //   if (!formikEdit?.values?.assessment) {
  //     formikEdit.setFieldValue("account", "")
  //     formikEdit.setFieldValue("custName", "")
  //   }

  //   formikEdit.setFieldValue("account", accountData.find((data) => data?.id === formikEdit?.values?.assessment?.assessmentCustomerAccount?.id)
  //   )
  //   formikEdit.setFieldValue("custName", customersData.find((data) => data?.id === formikEdit?.values?.assessment?.assessmentCustomerAccount?.assessmentCustomer?.id)
  //   )

  // }, [formik?.values?.assessment])

  const classes = useStyles();

  const getCustomerSelectedValue = (data) => {
    formik.setFieldValue("custName", data);
    setSelectedCustValue(data);
  };

  const getAccountSelectedValue = (data) => {
    formik.setFieldValue("account", data);
    setSelectedAccountValue(data);
  };

  // for this function changed the formik values to this component state variables
  const handleArchiveClick = () => {
    setViewArchived(!viewArchived);
    if (viewArchived === false) {
      dispatch(
        getArchivedPublishAssessment({
          assessmentCustomerId: selectedCustValue?.id,
          assessmentCustomerAccountId: selectedAccountValue?.id,
        }),
      );
    }
    // else {
    //   dispatch(getPublishAssessment())
    // }
    else {
      // if (formik?.values?.custName && !formik?.values?.accountName) {
      //   dispatch(getPublishAssessmentByCustomerId({ assessmentCustomerId: formik?.values?.custName?.id }))
      // }
      // if (formik?.values?.custName && formik?.values?.accountName) {
      //   dispatch(getPublishAssessmentById({ assessmentCustomerAccountId: formik?.values?.account?.id }))
      // }
      // else {
      //   dispatch(getPublishAssessment())
      // }
      if (selectedCustValue && selectedAccountValue) {
        dispatch(
          getPublishAssessmentById({
            assessmentCustomerAccountId: selectedAccountValue?.id,
          }),
        );
      } else if (selectedCustValue) {
        dispatch(
          getPublishAssessmentByCustomerId({
            assessmentCustomerId: selectedCustValue?.id,
          }),
        );
      } else {
        dispatch(getPublishAssessment());
      }
    }
  };

  const handleSubmit = async () => {
    if (showAdd) {
      const result = await formik.submitForm();
      return result;
    } else if (showEdit) {
      const result = await formikEdit.submitForm();
      return result;
    } else if (showCutoffDate) {
      const result = await formikCutoffDateEdit.submitForm();
      return result;
    }
  };

  // useEffect(() => {
  //   const currentState = location.state || {};
  //   const newState = { ...currentState };

  //   if (!selectedCustValue) {
  //     delete newState.customer;
  //     delete newState.account;
  //   } else {
  //     newState.customer = selectedCustValue;

  //     if (!selectedAccountValue) {
  //       delete newState.account;
  //     } else {
  //       newState.account = selectedAccountValue;
  //     }
  //   }

  //   if (JSON.stringify(currentState) !== JSON.stringify(newState)) {
  //     navigate(location.pathname, {
  //       replace: true,
  //       state: newState,
  //     });
  //     if (!selectedCustValue && !selectedAccountValue) {
  //       !viewArchived ? dispatch(getPublishAssessment) : dispatch(getArchivedPublishAssessment)
  //     }
  //   }
  // }, [selectedCustValue, selectedAccountValue]);

  const assessmentOptions = Array.isArray(batchAssessmentListViewData?.data)
    ? batchAssessmentListViewData.data.filter(
        (item) => item?.status !== "Published",
      )
    : [];

  console.log(!location?.state?.customer && !location?.state?.account);

  return (
    <>
      <>
        {/* {location?.state?.permissions?.find(
          (e) =>
            e.applicationService?.name?.split(".")[
            e?.applicationService?.name?.split(".")?.length - 1
            ] === "uploadClientUsers"
        ) && ( */}
        <Box position="relative" sx={{ left: "2.5rem" }}>
          <label style={{ position: "absolute", right: 120, zIndex: 3 }}>
            <MuiTooltip
              title={!viewArchived ? "View Archived Records" : "View All"}
              placement="bottom"
            >
              {!viewArchived ? (
                <IconButton
                  onClick={handleArchiveClick}
                  color="primary"
                  aria-label="upload picture"
                  component="span"
                >
                  <ArchiveIcon className={classes.iconResponsive} />
                </IconButton>
              ) : (
                <IconButton
                  onClick={handleArchiveClick}
                  color="primary"
                  aria-label="upload picture"
                  component="span"
                >
                  <ViewCozyIcon className={classes.iconResponsive} />
                </IconButton>
              )}
            </MuiTooltip>
          </label>
          {/* )} */}
          {location?.state?.permissions?.find(
            (e) =>
              e.applicationService?.name?.split(".")[
                e?.applicationService?.name?.split(".")?.length - 1
              ] === "uploadClientUsers",
          ) && (
            <label
              htmlFor="icon-button-file"
              style={{ position: "absolute", right: 80, zIndex: 1 }}
            >
              <Input
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                id="icon-button-file"
                type="file"
                sx={{ display: "none" }}
                name="l1MenuIcon"
                onChange={handleFile}
                required={true}
              />
              <MuiTooltip title="Bulk Upload" placement="bottom">
                <IconButton
                  color="primary"
                  aria-label="upload picture"
                  component="span"
                >
                  <CloudUploadIcon className={classes.iconResponsive} />
                </IconButton>
              </MuiTooltip>
            </label>
          )}

          {location?.state?.permissions?.find(
            (e) =>
              e.applicationService?.name?.split(".")[
                e?.applicationService?.name?.split(".")?.length - 1
              ] === "uploadClientUsers",
          ) && (
            <label style={{ position: "absolute", right: 40, zIndex: 3 }}>
              <MuiTooltip title="Download Template" placement="bottom">
                <a
                  href={`${ASSESSMENT_BASE_URL}/v1/api/excel-parser/template/batch-upload-assessment`}
                  target="_blank"
                >
                  <IconButton
                    color="primary"
                    aria-label="upload picture"
                    component="span"
                  >
                    <FileDownloadIcon className={classes.iconResponsive} />
                  </IconButton>
                </a>
              </MuiTooltip>
            </label>
          )}
        </Box>
        <HeaderDropDown
          sx={{ marginTop: "1rem" }}
          heading="Create & Publish Assessment"
          assessmentTypeData={assessmentTypeData}
          assessmentType={assessmentType}
          // setAssessmentType={setAssessmentType}
          setAssessmentType={(value) => dispatch(setAssessmentType(value))}
        />

        {/* <Stack
          flexDirection="row"
          justifyContent="space-around"
          alignItems="center"
          sx={{ marginBottom: "1rem" }}
        >
          <Grid spacing={1} container style={{ display: 'flex', alignItems: 'center', justifyContent: "flex-end" }}>
            <Grid item xs={12} sm={12} md={3}>
              <MuiAutocomplete
                name="custName"
                options={customersData}
                setValue={(name, newValue) => {

                  formik.setFieldValue(name, newValue)
                  formik.setFieldValue("account", "")
                }
                }
                value={formik.values.custName}
                optionValue="customerName"
                label="Customer"
               
                error={formik.touched.custName && Boolean(formik.errors.custName)}
                helperText={formik.touched.custName && formik.errors.custName}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={3}>
            
              <MuiAutocomplete
                name="account"
                options={accountIdData}
                setValue={(name, newValue) =>
                  formik.setFieldValue(name, newValue)
                }
                value={formik.values.account}
                optionValue="accountName"
              
                label="Account Name"
               
                error={
                  formik.touched.account && Boolean(formik.errors.account)
                }
                helperText={formik.touched.account && formik.errors.account}
              />

            
            </Grid>
          </Grid>
        </Stack> */}

        <MuiDataGrid
          setShowAdd={
            location?.state?.permissions?.find(
              (e) =>
                e.applicationService?.name?.split(".")[
                  e?.applicationService?.name?.split(".")?.length - 1
                ] === "createAssessTrack",
            ) &&
            !viewArchived &&
            showAddModel
          }
          setShowEdit={
            location?.state?.permissions?.find(
              (e) =>
                e.applicationService?.name?.split(".")[
                  e?.applicationService?.name?.split(".")?.length - 1
                ] === "updateAssessTrack",
            ) &&
            !viewArchived &&
            showEditModal
          }
          setShowDelete={
            location?.state?.permissions?.find(
              (e) =>
                e.applicationService?.name?.split(".")[
                  e?.applicationService?.name?.split(".")?.length - 1
                ] === "deleteAssessTrack",
            ) &&
            !viewArchived &&
            showDelete
          }
          // assessmentType={assessmentType}
          isAccount={true}
          isCustomer={true}
          getAccountSelectedValue={(data) => getAccountSelectedValue(data)}
          getCustomerSelectedValue={(data) => getCustomerSelectedValue(data)}
          selectedCustValue={
            location?.state?.customer ? location?.state?.customer : ""
          }
          selectedAccountValue={
            location?.state?.account ? location?.state?.account : ""
          }
          getCallBackCustomer={(data) =>
            viewArchived
              ? getArchivedPublishAssessment({
                  assessmentCustomerId: data,
                  assessmentCustomerAccountId: selectedAccountDataList?.id,
                })
              : getPublishAssessmentByCustomerId({ assessmentCustomerId: data })
          }
          getCallBackOne={
            !viewArchived ? getPublishAssessment : getArchivedPublishAssessment
          }
          getCallBackTwo={(data) =>
            viewArchived
              ? getArchivedPublishAssessment({
                  assessmentCustomerId: selectedCustomerDataList?.id,
                  assessmentCustomerAccountId: data,
                })
              : getPublishAssessmentById({ assessmentCustomerAccountId: data })
          }
          // getCallBack={(data)=>getPublishAssessmentById({assessmentCustomerAccountId : data})}
          // setShowAdd={ showAddModel}
          // setShowEdit={showEditModal}
          // setShowDelete={showDelete
          // }

          toolbarColumn={true}
          // toolbarFilter={true}
          toolbarDensity={true}
          toolbarExport={true}
          data={data}
          select={(data) => dispatch(rowSelect(data))}
        />
      </>

      {/* <ModalPopUp
        open={showAdd}
        handleClose={closeModel}
        closeModel={closeModel}
      >
        <Box
       
          className={classes.rootbox}
          component="form"
          noValidate
          onSubmit={formik.handleSubmit}
        >
          <ModalCloseBtn close={closeModel} />
          <div className={classes.text_responsive}> */}

      {showAdd && (
        <CommonCurdPopUp
          heading={`Create Assessment`}
          mediumScreen={true}
          close={closeModel}
          handleSubmit={handleSubmit}
          loading={loading}
        >
          <Grid container>
            <Grid item xs={12} sm={12} md={0.5} lg={0.5}></Grid>
            <Grid item xs={12} sm={12} md={11}>
              <MuiAutocomplete
                name="assessmentType"
                options={assessmentTypeData}
                setValue={(name, newValue) => {
                  formik.setFieldValue(name, newValue);
                  formik.setFieldValue("account", "");
                  formik.setFieldValue("assessment", "");
                  formik.setFieldValue("templateDisplayName", "");
                  formik.setFieldValue("client", "");
                }}
                value={formik.values.assessmentType}
                optionValue="assessmentType"
                label="Assessment Type"
                required={true}
                error={
                  formik.touched.assessmentType &&
                  Boolean(formik.errors.assessmentType)
                }
                helperText={
                  formik.touched.assessmentType && formik.errors.assessmentType
                }
              />

              <MuiAutocomplete
                name="custName"
                options={customersData}
                setValue={(name, newValue) => {
                  formik.setFieldValue(name, newValue);
                  formik.setFieldValue("account", "");
                  formik.setFieldValue("assessment", "");
                  formik.setFieldValue("templateDisplayName", "");
                  formik.setFieldValue("client", "");
                }}
                value={formik.values.custName}
                optionValue="customerName"
                label="Customer"
                required={true}
                error={
                  formik.touched.custName && Boolean(formik.errors.custName)
                }
                helperText={formik.touched.custName && formik.errors.custName}
              />

              <MuiAutocomplete
                name="account"
                options={
                  formik.values.custName && accountIdData ? accountIdData : []
                }
                setValue={(name, newValue) => {
                  formik.setFieldValue(name, newValue);
                  formik.setFieldValue("assessment", "");
                  formik.setFieldValue("templateDisplayName", "");
                  formik.setFieldValue("client", "");
                }}
                value={formik.values.account}
                optionValue="accountName"
                // optionSecValue="accountName"
                label="Account Name"
                required={true}
                error={formik.touched.account && Boolean(formik.errors.account)}
                helperText={formik.touched.account && formik.errors.account}
              />

              <MuiAutocomplete
                name="assessment"
                options={
                  assessmentTemplateData?.length > 0
                    ? assessmentTemplateData?.filter(
                        (data) =>
                          data?.assessmentCustomerAccount?.id ===
                            formik?.values.account?.id &&
                          data?.assessmentType?.assessmentType ===
                            (formik.values?.assessmentType?.assessmentType ||
                              assessmentType?.assessmentType),
                      )
                    : []
                }
                setValue={(name, newValue) => {
                  formik.setFieldValue(name, newValue);
                }}
                value={formik.values.assessment}
                optionValue="assessmentTemplateName"
                label="Assessment Template Name"
                required={true}
                error={
                  formik.touched.assessment && Boolean(formik.errors.assessment)
                }
                helperText={
                  formik.touched.assessment && formik.errors.assessment
                }
              />

              <MyTextInput
                InputLabelProps={{ shrink: true }}
                label="Template Display Name *"
                type="text"
                name="templateDisplayName"
                fullWidth={true}
                margin="normal"
                id="templateDisplayName"
                value={formik.values.templateDisplayName}
                // onChange={formik.handleChange}
                error={
                  formik.touched.templateDisplayName &&
                  Boolean(formik.errors.templateDisplayName)
                }
                helperText={
                  formik.touched.templateDisplayName &&
                  formik.errors.templateDisplayName
                }
                disabled={formik.values.templateDisplayName ? "" : "disabled"}
              />

              {/* <MuiAutocomplete
                  name="client"
                  options={custUserData?.length > 0 ? custUserData.filter(item => item?.assessmentCustomer?.id === formik?.values?.account?.id) : []}
                  setValue={(name, newValue) =>
                    formik.setFieldValue(name, newValue)
                  }
                  value={formik.values.client}
                  innerValue={true}
              optionValue="assessmentCustomerUserDetail"
              optionSecValue="firstName"
              optionThirdValue="lastName"
                  label="Client"
                  required={true}
                  error={
                    formik.touched.client && Boolean(formik.errors.client)
                  }
                  helperText={formik.touched.client && formik.errors.client}
                />  */}
              <Autocomplete
                name="client"
                options={
                  custUserData?.length > 0
                    ? custUserData.filter(
                        (item) =>
                          item?.assessmentCustomerAccount?.id ===
                          formik?.values?.account?.id,
                      )
                    : []
                }
                getOptionLabel={(option) =>
                  option &&
                  `${option?.assessmentCustomerUserDetail?.firstName} ${option?.assessmentCustomerUserDetail?.lastName}-${option?.email}`
                }
                value={formik.values.client}
                onChange={(event, newValue) =>
                  formik.setFieldValue("client", newValue)
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Client"
                    required={true}
                    error={
                      formik.touched.client && Boolean(formik.errors.client)
                    }
                    helperText={formik.touched.client && formik.errors.client}
                  />
                )}
                sx={{ marginTop: "1rem" }}
                disabled={!formik?.values?.account}
              />
              {/* <MyTextInput
                  label="Email"
                  type="email"
                  name="email"
                  fullWidth={true}
                  margin="normal"
                  id="email"
                  InputLabelProps={{ shrink: true }}
                  value={formik.values.client?.email}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.email && Boolean(formik.errors.email)
                  }
                  helperText={formik.touched.email && formik.errors.email}
                  disabled
                /> */}
              <MyTextInput
                label="Comments"
                type="comments"
                name="comments"
                fullWidth={true}
                margin="normal"
                id="comments"
                value={formik.values.comments}
                onChange={formik.handleChange}
                error={
                  formik.touched.comments && Boolean(formik.errors.comments)
                }
                helperText={formik.touched.comments && formik.errors.comments}
              />
              {/* <Box style={{ width: "100%", textAlign: "center" }} >

              <FormSubmitButton onClick={formik?.handleSubmit} type="submit" variant="contained">
                Submit
              </FormSubmitButton>
            </Box> */}
            </Grid>
          </Grid>
        </CommonCurdPopUp>
      )}

      {showEdit && (
        <CommonCurdPopUp
          heading={`Update Assessment`}
          mediumScreen={true}
          close={() => setShowEdit(false)}
          handleSubmit={handleSubmit}
          loading={loading}
        >
          <Grid container>
            <Grid item xs={12} sm={12} md={0.5} lg={0.5}></Grid>
            <Grid item xs={12} sm={12} md={11}>
              <FormControl sx={{ marginTop: "1rem" }} fullWidth>
                <InputLabel id="demo-simple-select-label">
                  Assessment Type
                </InputLabel>
                <Select
                  disabled
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  name="assessmentType"
                  defaultValue={formikEdit?.values?.assessmentType}
                  value={formikEdit?.values?.assessmentType}
                  label="Assessment Type"
                  onChange={formikEdit.handleChange}
                  error={
                    formikEdit.touched.assessmentType &&
                    Boolean(formikEdit.errors.assessmentType)
                  }
                >
                  {assessmentTypeData?.map((option) => {
                    return (
                      <MenuItem key={option.id} value={option.id}>
                        {option.assessmentType}
                      </MenuItem>
                    );
                  })}
                </Select>
                <FormHelperText error={true} sx={{ color: "red" }}>
                  {formikEdit.touched.accountName &&
                    formikEdit.errors.accountName}
                </FormHelperText>
              </FormControl>

              <MuiAutocomplete
                name="custName"
                options={customersData}
                setValue={(name, newValue) => {
                  formikEdit.setFieldValue(name, newValue);
                  formikEdit.setFieldValue("account", "");
                  formikEdit.setFieldValue("assessment", "");
                  formikEdit.setFieldValue("templateDisplayName", "");
                }}
                disabled
                value={formikEdit.values.custName}
                optionValue="customerName"
                label="Customer"
                required={true}
                error={
                  formikEdit.touched.custName &&
                  Boolean(formikEdit.errors.custName)
                }
                helperText={
                  formikEdit.touched.custName && formikEdit.errors.custName
                }
              />

              <MuiAutocomplete
                name="account"
                options={
                  formik?.values?.custName
                    ? accountData.length > 0
                      ? accountData
                      : accountIdData
                    : []
                }
                setValue={(name, newValue) => {
                  formikEdit.setFieldValue(name, newValue);
                  formikEdit.setFieldValue("assessment", "");
                  formikEdit.setFieldValue("templateDisplayName", "");
                  formikEdit.setFieldValue("client", "");
                }}
                disabled
                value={formikEdit.values.account}
                optionValue="accountName"
                // optionSecValue="accountName"
                label="Account Name"
                required={true}
                error={
                  formikEdit.touched.account &&
                  Boolean(formikEdit.errors.account)
                }
                helperText={
                  formikEdit.touched.account && formikEdit.errors.account
                }
              />

              <MuiAutocomplete
                name="assessment"
                options={
                  assessmentTemplateData?.length > 0 &&
                  formikEdit?.values?.account?.id
                    ? assessmentTemplateData?.filter(
                        (data) =>
                          data?.assessmentCustomerAccount?.id ===
                          formikEdit?.values?.account?.id,
                      )
                    : []
                }
                setValue={(name, newValue) =>
                  formikEdit.setFieldValue(name, newValue)
                }
                value={formikEdit.values.assessment}
                // defaultValue={formikEdit?.values?.assessment}
                optionValue="assessmentTemplateName"
                label="Assessment Template Name"
                required={true}
                error={
                  formikEdit.touched.assessment &&
                  Boolean(formikEdit.errors.assessment)
                }
                helperText={
                  formikEdit.touched.assessment && formikEdit.errors.assessment
                }
                disabled={
                  formikEdit.values.status === "Published" ||
                  formikEdit.values.status === "Completed"
                    ? "disabled"
                    : ""
                }
              />

              <MyTextInput
                InputLabelProps={{ shrink: true }}
                label="Template Display Name"
                type="text"
                name="templateDisplayName"
                fullWidth={true}
                margin="normal"
                id="templateDisplayName"
                value={formikEdit.values.templateDisplayName}
                // onChange={formikEdit.handleChange}
                error={
                  formikEdit.touched.templateDisplayName &&
                  Boolean(formikEdit.errors.templateDisplayName)
                }
                helperText={
                  formikEdit.touched.templateDisplayName &&
                  formikEdit.errors.templateDisplayName
                }
                disabled={
                  (formik.values.templateDisplayName ? "" : "disabled") ||
                  (formikEdit.values.status === "Published" ||
                  formikEdit.values.status === "Completed"
                    ? "disabled"
                    : "")
                }
              />
              {/* <FormControl sx={{ marginTop: "1rem" }} fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    Customer *
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    name="custName"
                    defaultValue={formikEdit.values.custName}
                    value={formikEdit.values.custName}
                    label="Customer"
                    onChange={formikEdit.handleChange}
                    error={
                      formikEdit.touched.custName &&
                      Boolean(formikEdit.errors.custName)
                    }
                  >
                    {customersData.map((option) => {
                      return (
                        <MenuItem
                          key={option.id}
                          value={option.id}
                        >
                          {option.customerName}
                        </MenuItem>
                      );
                    })}
                  </Select>
                  <FormHelperText error={true} sx={{ color: "red" }}>
                    {formikEdit.touched.custName && formikEdit.errors.custName}
                  </FormHelperText>
                </FormControl>

                <FormControl sx={{ marginTop: "1rem" }} fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    Account Name *
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    name="account"
                    defaultValue={formikEdit?.values?.account}
                    value={formikEdit.values.account}
                    error={
                      formikEdit.touched.account &&
                      Boolean(formikEdit.errors.account)
                    }
                    label="Account Name *"
                    onChange={formikEdit.handleChange}
                    disabled={true}
                  >
                    {accountIdData.length > 0 &&
                      accountIdData.map((item) => (
                        <MenuItem key={item.id} value={item.id}>
                          {item?.assessmentCustomer?.customerName}-
                          {item.accountName}
                        </MenuItem>
                      ))}
                  </Select>
                  <FormHelperText error={true} sx={{ color: "red" }}>
                    {formikEdit.touched.account && formikEdit.errors.account}
                  </FormHelperText>
                </FormControl> */}

              {/* <MuiAutocomplete
                  name="account"
                  options={accountData}
                  setValue={(name, newValue) =>
                    formikEdit.setFieldValue(name, newValue)
                  }
                  value={formikEdit.values.account}
                  defaultValue={formikEdit?.values?.account}
                  optionValue="customerName"
                  optionSecValue="accountName"
                  label="Account Name"
                  required={true}
                  error={
                    formikEdit.touched.account &&
                    Boolean(formikEdit.errors.account)
                  }
                  helperText={
                    formikEdit.touched.account && formikEdit.errors.account
                  }
                  disabled={
                    formikEdit.values.status === "Published" ||
                    formikEdit.values.status === "Completed"
                      ? "disabled"
                      : ""
                  }
                />  */}

              {/* <MuiAutocomplete
                  name="client"
                  options={custUserData?.length > 0 && custUserData?.filter(value => value?.assessmentCustomer?.id === formikEdit?.values?.account?.id)}
                  setValue={(name, newValue) =>
                    formikEdit.setFieldValue(name, newValue)
                  }
                  defaultValue={formikEdit?.values?.client}
                  value={formikEdit.values.client}
                  innerValue={true}
                  optionValue="assessmentCustomerUserDetail"
                  optionSecValue="firstName"
                  optionThirdValue="lastName"
                  label="Client"
                  required={true}
                  error={
                    formikEdit.touched.client && Boolean(formikEdit.errors.client)
                  }
                  helperText={formikEdit.touched.client && formikEdit.errors.client}
                /> */}
              {/* <Autocomplete
                  name="client"
                  options={
                    custUserData?.length > 0
                      ? custUserData
                        .filter(
                          (item) =>
                            item?.assessmentCustomerAccount?.id ===
                            formikEdit?.values?.account?.id
                        )
                      : []
                  }
                  getOptionLabel={(option) =>
                    option &&
                    `${option?.assessmentCustomerUserDetail?.firstName} ${option?.assessmentCustomerUserDetail?.lastName}-${option?.email}`
                  }
                 
                  value={formikEdit.values.client}
                  onChange={(event, newValue) =>
                    formikEdit.setFieldValue("client", newValue)
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Client"
                      required={true}
                      error={
                        formikEdit.touched.client &&
                        Boolean(formikEdit.errors.client)
                      }
                      helperText={
                        formikEdit.touched.client && formikEdit.errors.client
                      }
                    />
                  )}
                  sx={{ marginTop: "1rem" }}
                  disabled={
                    !formikEdit?.values?.account ||
                      formikEdit.values.status === "Published" ||
                      formikEdit.values.status === "Completed"
                      ? "disabled"
                      : ""
                  }
                /> */}
              <FormControl sx={{ marginTop: "1rem" }} fullWidth>
                <InputLabel id="demo-simple-select-label">Client *</InputLabel>
                <Select
                  MenuProps={{
                    PaperProps: {
                      sx: {
                        maxHeight: 250,
                        minWidth: 250,
                      },
                    },
                  }}
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  name="client"
                  value={formikEdit.values.client}
                  error={
                    formikEdit.touched.client &&
                    Boolean(formikEdit.errors.client)
                  }
                  defaultValue={formikEdit.values.client}
                  label="client"
                  onChange={formikEdit.handleChange}
                  disabled={
                    !formikEdit?.values?.account ||
                    formikEdit.values.status === "Published" ||
                    formikEdit.values.status === "Completed"
                      ? "disabled"
                      : ""
                  }
                >
                  {custUserData?.length > 0 &&
                    custUserData
                      .filter(
                        (item) =>
                          item?.assessmentCustomerAccount?.id ===
                          formikEdit?.values?.account?.id,
                      )
                      .map((option) => {
                        return (
                          <MenuItem key={option.id} value={option.id}>
                            {option?.assessmentCustomerUserDetail?.firstName}{" "}
                            {option?.assessmentCustomerUserDetail?.lastName}-
                            {option?.email}
                          </MenuItem>
                        );
                      })}
                </Select>
                {formikEdit?.errors?.client && (
                  <FormHelperText error={true} sx={{ color: "red" }}>
                    {formikEdit.touched.client && formikEdit.errors.client}
                  </FormHelperText>
                )}
              </FormControl>
              {/* <MyTextInput
                  label="Email"
                  type="email"
                  name="email"
                  fullWidth={true}
                  margin="normal"
                  id="email"
                  value={formikEdit.values.client?.email}
                  onChange={formikEdit.handleChange}
                  error={
                    formikEdit.touched.comments &&
                    Boolean(formikEdit.errors.comments)
                  }
                  helperText={
                    formikEdit.touched.comments && formikEdit.errors.comments
                  }
                  disabled
                /> */}
              <FormControl sx={{ marginTop: "1rem" }} fullWidth>
                <InputLabel id="demo-simple-select-label">
                  Assessment Status *
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  name="status"
                  value={formikEdit.values.status}
                  disabled={selectedData?.assessmentStatus === "Completed"}
                  error={
                    formikEdit.touched.status &&
                    Boolean(formikEdit.errors.status)
                  }
                  label="Assessment Status"
                  onChange={formikEdit.handleChange}
                >
                  {assessmentStatusData.length > 0 &&
                  (selectedData?.assessmentStatus === "Published" ||
                    selectedData?.assessmentStatus === "Completed")
                    ? assessmentStatusData
                        .filter(
                          (data) =>
                            data?.assessmentStatus === "Completed" ||
                            data?.assessmentStatus === "Published",
                        )
                        .map((item) => {
                          return (
                            <MenuItem
                              key={item.id}
                              value={item.assessmentStatus}
                            >
                              {item.assessmentStatus}
                            </MenuItem>
                          );
                        })
                    : assessmentStatusData
                        .filter(
                          (data) =>
                            data?.assessmentStatus === "New" ||
                            data?.assessmentStatus === "Pending" ||
                            data?.assessmentStatus === "Hold" ||
                            data?.assessmentStatus === "Archived",
                        )
                        .map((item) => (
                          <MenuItem key={item.id} value={item.assessmentStatus}>
                            {item.assessmentStatus}
                          </MenuItem>
                        ))}
                </Select>
                {formikEdit?.errors?.status && (
                  <FormHelperText error={true} sx={{ color: "red" }}>
                    {formikEdit.touched.status && formikEdit.errors.status}
                  </FormHelperText>
                )}
              </FormControl>
              <MyTextInput
                label="Comments"
                type="comments"
                name="comments"
                fullWidth={true}
                margin="normal"
                id="comments"
                value={formikEdit.values.comments}
                onChange={formikEdit.handleChange}
                error={
                  formikEdit.touched.comments &&
                  Boolean(formikEdit.errors.comments)
                }
                helperText={
                  formikEdit.touched.comments && formikEdit.errors.comments
                }
              />
              {/* <Box style={{ width: "100%", textAlign: "center" }} >

              <FormSubmitButton onClick={formikEdit?.handleSubmit} type="submit" variant="contained">
                Submit
              </FormSubmitButton>
            </Box> */}
            </Grid>
          </Grid>
        </CommonCurdPopUp>
      )}

      {/* <ModalPopUp
        open={showEdit}
        handleClose={() => setShowEdit(false)}
        closeModel={() => setShowEdit(false)}
      >
        <Box
         
          className={classes.rootbox}
          component="form"
          noValidate
          onSubmit={formikEdit.handleSubmit}
        >
          <ModalCloseBtn close={() => setShowEdit(false)} />
          <div className={classes.text_responsive}> */}

      {/* </div> */}

      {/* <FormSubmitButton type="submit" variant="contained">
            Submit
          </FormSubmitButton>
        </Box>
      </ModalPopUp> */}

      {showCutoffDate && (
        <CommonCurdPopUp
          heading={`Cut Off Date`}
          // smallScreen={true}
          customMarginLeft={true}
          customMarginLeftWidth="40vw"
          customWidth="35vw"
          close={() => setShowCutoffDate(false)}
          handleSubmit={handleSubmit}
          loading={loading}
        >
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12} md={8} margin="auto">
              <MyTextInput
                label="Cut Off Date"
                InputLabelProps={{ shrink: true }}
                inputProps={{ min: format(new Date(), "yyyy-MM-dd") }}
                type="date"
                name="cutoffDate"
                fullWidth={true}
                margin="normal"
                id="cutoffDate"
                value={formikCutoffDateEdit.values.cutoffDate}
                onChange={(e) =>
                  formikCutoffDateEdit.setFieldValue(
                    "cutoffDate",
                    e.target.value,
                  )
                }
                required={true}
                error={
                  formikCutoffDateEdit.touched.cutoffDate && dateErr
                    ? Boolean(dateErr)
                    : Boolean(formikCutoffDateEdit.errors.cutoffDate)
                }
                helperText={
                  formikCutoffDateEdit.touched.cutoffDate && dateErr
                    ? dateErr
                    : formikCutoffDateEdit.errors.cutoffDate
                }
              />
            </Grid>
          </Grid>
          {/* <Box style={{ width: "100%", textAlign: "center" }} >

          <FormSubmitButton onClick={formikCutoffDateEdit?.handleSubmit} type="submit" variant="contained">
            Submit
          </FormSubmitButton>
        </Box> */}
        </CommonCurdPopUp>
      )}
      {/* <ModalPopUp
        open={showCutoffDate}
        handleClose={() => setShowCutoffDate(false)}
        closeModel={() => setShowCutoffDate(false)}
      >
        <Box
          sx={{ ...style, width: 900 }}
          className={classes.cutoff_box}
          component="form"
          noValidate
          onSubmit={formikCutoffDateEdit.handleSubmit}
        >
          <ModalCloseBtn
            close={() => {
              setShowCutoffDate(false);
              formikCutoffDateEdit.setFieldValue("cutoffDate", "");
            }}
          />
          <div style={{ width: "50rem" }} className={classes.responsive_field}> */}

      <ModalPopUp
        open={showReminderFreq}
        handleClose={() => setShowReminderFreq(false)}
        closeModel={() => setShowReminderFreq(false)}
      >
        <Box
          sx={{ ...style, width: 900 }}
          component="form"
          noValidate
          onSubmit={formikEdit.handleSubmit}
        >
          <ModalCloseBtn close={() => setShowReminderFreq(false)} />
          <div style={{ width: "50rem" }}>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={8} margin="auto">
                <MyTextInput
                  label="Reminder Frequency(days)"
                  type="number"
                  name="reminderFreq"
                  fullWidth={true}
                  margin="normal"
                  id="reminderFreq"
                  value={formikEdit.values.reminderFreq}
                  onChange={formikEdit.handleChange}
                  error={
                    formikEdit.touched.reminderFreq &&
                    Boolean(formikEdit.errors.reminderFreq)
                  }
                  helperText={
                    formikEdit.touched.reminderFreq &&
                    formikEdit.errors.reminderFreq
                  }
                />
              </Grid>
            </Grid>
          </div>

          <FormSubmitButton type="submit" variant="contained">
            Submit
          </FormSubmitButton>
        </Box>
      </ModalPopUp>

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        {/* <DialogTitle>Filters</DialogTitle> */}

        <DialogTitle
          sx={{
            px: 3,
            py: 2,
            position: "relative",
          }}
        >
          <Stack
            direction="row"
            spacing={1}
            justifyContent="center"
            alignItems="center"
          >
            <Typography
              // variant="h6"
              // component="span"
              sx={{ fontSize: "1.25rem" }}
            >
              Tag to Batch
            </Typography>
            <Tooltip
              arrow
              componentsProps={{
                tooltip: {
                  sx: {
                    bgcolor: "#FFFFFF",
                    color: "#000000",
                    border: "1px solid #D9E2EC",
                    boxShadow: "0px 4px 12px rgba(0,0,0,0.12)",
                    maxWidth: 350,
                    p: 2,
                  },
                },
                arrow: { sx: { color: "#FFFFFF" } },
              }}
              placement="bottom-start"
              title={
                <>
                  <Typography variant="subtitle2" fontWeight={600}>
                    Each assessment can be tagged to only one batch at a time.
                    To assign it to a different batch, first remove the existing
                    batch tag.
                  </Typography>
                </>
              }
            >
              <InfoOutlinedIcon
                fontSize="small"
                color="info"
                sx={{ cursor: "pointer" }}
              />
            </Tooltip>
          </Stack>

          <IconButton
            aria-label="cancel"
            size="small"
            onClick={() => setOpen(false)}
            sx={{
              position: "absolute",
              right: 16,
              top: "50%",
              transform: "translateY(-50%)",
            }}
          >
            <CancelIcon color="error" />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          <Box display="flex" flexDirection="column" mt={1}>
            {batchDataByTracking?.length > 0 ? (
              <Box>
                <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
                  Tagged Batch
                </Typography>

                <Stack
                  direction="row"
                  spacing={1}
                  flexWrap="wrap"
                  useFlexGap
                  sx={{ mb: 1 }}
                >
                  <Chip
                    sx={{
                      "& .MuiChip-deleteIcon": {
                        color: "#da2128",
                        display: "block !important",
                        visibility: "visible !important",
                        opacity: 1,
                      },
                    }}
                    key={1}
                    label={batchDataByTracking[0]?.name}
                    deleteIcon={<CancelIcon color="#da2128" />}
                    onDelete={() =>
                      showAssessmentDelete(batchDataByTracking[0])
                    }
                    color="primary"
                    variant="outlined"
                  />
                </Stack>
              </Box>
            ) : null}

            {/* <Typography
                variant="subtitle2"
                sx={{  fontWeight: 600, }}
              >
               Tag to Batch
              </Typography> */}

            <MuiAutocomplete
              name="customer"
              disabled={
                batchDataByTracking?.length > 0 ||
                assessmentOptions.length === 0
              }
              options={assessmentOptions}
              setValue={(name, newValue) => {
                setBatchName(newValue);
                // dispatch(getAccountById({ assessmentCustomerId: newValue?.id }))
                // dispatch(getBatchPublishAssessmentById({ customerId: newValue?.id }))
              }}
              value={batchName}
              size="small"
              height="100%"
              fullWidth={true}
              noMargin
              optionValue="name"
              // optionSecValue="code"
              label="Tag to Batch"
            />

            {/* Customer */}

            {/* Account */}

            {/* Assessment Type */}
          </Box>
        </DialogContent>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            marginBottom: "1rem",
          }}
        >
          <FormSubmitButton
            onClick={handleAddTrackingAssessmentToBatch}
            type="submit"
            variant="contained"
          >
            Submit
          </FormSubmitButton>
        </Box>
      </Dialog>

      <ConfirmDialog
        confirmDialog={confirmDialog}
        setConfirmDialog={(obj) => handleSetConfirmDialog(obj)}
      />
      <MicrositeConfirmDialog
        confirmDialog={forceDelConfirmDialog}
        setConfirmDialog={(obj) => handleSetForceDelConfirmDialog(obj)}
      />

      {errMessage && <ErrorNotifier message={errMessage} />}
      {message && <Notifier message={message} />}
    </>
  );
};

export default ConfigAndPublish;
